"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndictmentAbilityHandler = exports.IndictmentActorAbilityFactory = exports.IndictmentAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class IndictmentAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Indictment;
        this.__typeName = "Indictment";
    }
}
exports.IndictmentAbilityArgs = IndictmentAbilityArgs;
let IndictmentActorAbilityFactory = class IndictmentActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Indictment", "OneEnemies", 3);
    }
};
IndictmentActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Indictment")
], IndictmentActorAbilityFactory);
exports.IndictmentActorAbilityFactory = IndictmentActorAbilityFactory;
let IndictmentAbilityHandler = class IndictmentAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 80)
            ],
            startAtAttachment: "head",
            projectileType: "RedSunOrb",
            projectilePath: "arc",
            onHit(sequence) {
                sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "feet"), "RedElectrifiedTornado"));
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(5),
                    effect: new core_1.VulnerabilityEffectArgs(4)
                });
                if (container.hasAttribute(ability.invokerId, "Charm_Executioner_1")) {
                    container.getHelpfulEffects(selectedEnemy, false)
                        .forEach(({ id }) => container.cancelEffect(sequence, id));
                }
            }
        });
    }
};
IndictmentAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Indictment)
], IndictmentAbilityHandler);
exports.IndictmentAbilityHandler = IndictmentAbilityHandler;
